import { DATA_ANALYTICS_COMMON } from '../models';

export const isMobile = (): boolean =>
  /android|iphone|ipad|kindle/i.test(navigator.userAgent);

export const getSystemEnvironment = (): string =>
  isMobile() ? DATA_ANALYTICS_COMMON.MOBILE : DATA_ANALYTICS_COMMON.DESKTOP;

export const getCountry = (value: string): string =>
  value ? value.substring(3, 5) : 'us';

export const getLanguage = (value: string): string =>
  value ? value.substring(0, 2) : 'en';

export const getValidValue = (value: string): string => (value ? value : '');

export const getEmailDomain = (email: string): string => {
  if (!email) return '';
  const parts = email.split('@');
  return parts.length > 1 ? parts[1] : '';
};

export const getCookieValue = (cookieName: string) => {
  const result = new RegExp(
    '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
  ).exec(document.cookie);
  return result ? result[1] : false;
};

export const getLoggedInStatus = (): boolean => {
  const accountTypeCookie = getCookieValue(DATA_ANALYTICS_COMMON.ACCOUNTTYPE);
  const accountCookie = getCookieValue(DATA_ANALYTICS_COMMON.ACCOUNT);
  if (accountTypeCookie || accountCookie) {
    return true;
  }
  return false;
};
